var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "scp-bm" },
    [
      _c(
        "div",
        {
          staticClass: "scp-bm-pipeline",
          attrs: {
            "aria-label": "How mechanism-linked biomarker discovery works",
          },
        },
        [
          _c("p", { staticClass: "scp-bm-pipeline-title" }, [
            _vm._v("How this search works"),
          ]),
          _c("ol", { staticClass: "scp-bm-pipeline-steps" }, [
            _vm._m(0),
            _vm._m(1),
            _vm._m(2),
            _vm._m(3),
            _c(
              "li",
              {
                staticClass: "scp-bm-pipeline-step",
                class: {
                  "scp-bm-pipeline-step--optional": !_vm.relevanceComplete,
                },
              },
              [
                _c("span", { staticClass: "scp-bm-pipeline-num" }, [
                  _vm._v("5"),
                ]),
                _c("span", { staticClass: "scp-bm-pipeline-text" }, [
                  _c("strong", [_vm._v("Relevance to hypothesis")]),
                  _vm._v(
                    " — optional LLM labels for how each biomarker relates to the hypothesis. "
                  ),
                  !_vm.relevanceComplete
                    ? _c("span", { staticClass: "scp-bm-pipeline-guide" }, [
                        _vm._v(
                          "To run this step, open the Actions panel and choose "
                        ),
                        _c("em", [_vm._v("Classify biomarker relevance")]),
                        _vm._v(
                          " (it appears at the top of Next steps after biomarkers are fetched)."
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]
            ),
          ]),
          _c("p", { staticClass: "scp-bm-pipeline-note" }, [
            _vm._v(
              " This discovers biomarkers associated with the hypothesis mechanism via shared-gene diseases — not a direct search of Evaluation fields (tissue, cell line, etc.). "
            ),
          ]),
        ]
      ),
      _vm.blockedReason
        ? _c(
            "div",
            { staticClass: "scp-bm-callout", attrs: { role: "status" } },
            [_vm._v(_vm._s(_vm.blockedReason))]
          )
        : _vm.evidence &&
          _vm.evidence.biomarkers &&
          _vm.evidence.biomarkers.length
        ? [
            _c(
              "div",
              { staticClass: "scp-bm-coverage" },
              [
                _vm.factorLabels.length
                  ? _c("span", [
                      _vm._v(
                        "Bridged via " + _vm._s(_vm.factorLabels.join(", "))
                      ),
                    ])
                  : _vm._e(),
                _c("span", { staticClass: "scp-bm-toolbar-sep" }, [
                  _vm._v("·"),
                ]),
                _c("span", [
                  _c("strong", [_vm._v(_vm._s(_vm.evidence.diseases.length))]),
                  _vm._v(
                    " associated disease" +
                      _vm._s(_vm.evidence.diseases.length === 1 ? "" : "s")
                  ),
                ]),
                _c("span", { staticClass: "scp-bm-toolbar-sep" }, [
                  _vm._v("·"),
                ]),
                _c("span", [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.evidence.biomarkers.length)),
                  ]),
                  _vm._v(
                    " biomarker" +
                      _vm._s(_vm.evidence.biomarkers.length === 1 ? "" : "s")
                  ),
                ]),
                _vm.evidence.truncated
                  ? [
                      _c("span", { staticClass: "scp-bm-toolbar-sep" }, [
                        _vm._v("·"),
                      ]),
                      _c("span", { staticClass: "text-muted" }, [
                        _vm._v(
                          "list truncated at limit " + _vm._s(_vm.fetchLimit)
                        ),
                      ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _vm.relevanceLoading
              ? _c("div", { staticClass: "scp-bm-relevance-status" }, [
                  _c("span", { staticClass: "scp-bm-relevance-marker" }),
                  _vm._v(" Classifying relevance… "),
                ])
              : _vm._e(),
            _vm.uniqueRoleLabels.length
              ? _c(
                  "div",
                  {
                    staticClass: "scp-bm-type-filters",
                    attrs: {
                      role: "group",
                      "aria-label": "Filter by biomarker role",
                    },
                  },
                  [
                    _c("span", { staticClass: "scp-bm-type-filters-label" }, [
                      _vm._v("Roles:"),
                    ]),
                    _vm._l(_vm.uniqueRoleLabels, function (label) {
                      return _c(
                        "button",
                        {
                          key: label,
                          staticClass: "scp-bm-type-bubble",
                          class: {
                            "scp-bm-type-bubble--off":
                              !_vm.isRoleVisible(label),
                          },
                          attrs: {
                            type: "button",
                            "aria-pressed": _vm.isRoleVisible(label)
                              ? "true"
                              : "false",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.toggleRoleFilter(label)
                            },
                          },
                        },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: _vm.isRoleVisible(label)
                                ? "eye-fill"
                                : "eye-slash",
                              "aria-hidden": "true",
                            },
                          }),
                          _vm._v(" " + _vm._s(label) + " "),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                )
              : _vm._e(),
            _vm.showDiseaseFilters
              ? _c(
                  "div",
                  {
                    staticClass: "scp-bm-type-filters",
                    attrs: {
                      role: "group",
                      "aria-label": "Filter biomarkers by disease",
                    },
                  },
                  [
                    _c("span", { staticClass: "scp-bm-type-filters-label" }, [
                      _vm._v("Diseases:"),
                    ]),
                    _vm._l(_vm.uniqueDiseaseLabels, function (label) {
                      return _c(
                        "button",
                        {
                          key: "disease-" + label,
                          staticClass: "scp-bm-type-bubble",
                          class: {
                            "scp-bm-type-bubble--off":
                              !_vm.isDiseaseVisible(label),
                          },
                          attrs: {
                            type: "button",
                            "aria-pressed": _vm.isDiseaseVisible(label)
                              ? "true"
                              : "false",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.toggleDiseaseFilter(label)
                            },
                          },
                        },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: _vm.isDiseaseVisible(label)
                                ? "eye-fill"
                                : "eye-slash",
                              "aria-hidden": "true",
                            },
                          }),
                          _vm._v(" " + _vm._s(label) + " "),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                )
              : _vm._e(),
            _vm.targetGeneMappingBubbleLabel
              ? _c(
                  "div",
                  {
                    staticClass: "scp-bm-type-filters",
                    attrs: {
                      role: "group",
                      "aria-label":
                        "Filter biomarkers by target gene among associated genes",
                    },
                  },
                  [
                    _c("span", { staticClass: "scp-bm-type-filters-label" }, [
                      _vm._v("Target gene to associated genes:"),
                    ]),
                    _c(
                      "button",
                      {
                        staticClass: "scp-bm-type-bubble",
                        class: {
                          "scp-bm-type-bubble--off":
                            !_vm.targetGeneOverlapFilter,
                        },
                        attrs: {
                          type: "button",
                          "aria-pressed": _vm.targetGeneOverlapFilter
                            ? "true"
                            : "false",
                        },
                        on: { click: _vm.toggleTargetGeneOverlapFilter },
                      },
                      [
                        _c("b-icon", {
                          attrs: {
                            icon: _vm.targetGeneOverlapFilter
                              ? "eye-fill"
                              : "eye-slash",
                            "aria-hidden": "true",
                          },
                        }),
                        _vm._v(
                          " " + _vm._s(_vm.targetGeneMappingBubbleLabel) + " "
                        ),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            !_vm.filteredBiomarkers.length
              ? _c("p", { staticClass: "scp-bm-filter-empty" }, [
                  _vm._v("No rows for the selected filters."),
                ])
              : [
                  _c("table", { staticClass: "scp-bm-table" }, [
                    _vm._m(4),
                    _c(
                      "tbody",
                      _vm._l(_vm.pagedBiomarkers, function (biomarker, index) {
                        return _c(
                          "tr",
                          { key: biomarker.biomarker + "-" + index },
                          [
                            _c("td", [
                              _vm.isUrl(biomarker.biomarker)
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: biomarker.biomarker,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                      },
                                    },
                                    [_vm._v(_vm._s(biomarker.displayLabel))]
                                  )
                                : _c("span", [
                                    _vm._v(_vm._s(biomarker.displayLabel)),
                                  ]),
                            ]),
                            _c(
                              "td",
                              { staticClass: "scp-bm-gene-cell" },
                              [
                                biomarker.geneList && biomarker.geneList.length
                                  ? _vm._l(
                                      biomarker.geneList,
                                      function (gene, gIdx) {
                                        return _c(
                                          "span",
                                          { key: gene + "-" + gIdx },
                                          [
                                            gIdx
                                              ? _c("span", [_vm._v(" | ")])
                                              : _vm._e(),
                                            _c(
                                              "span",
                                              {
                                                class: {
                                                  "scp-bm-gene-shared":
                                                    _vm.isTargetGene(gene),
                                                },
                                                attrs: {
                                                  title: _vm.isTargetGene(gene)
                                                    ? "Matches the hypothesis target gene"
                                                    : null,
                                                },
                                              },
                                              [_vm._v(_vm._s(gene))]
                                            ),
                                          ]
                                        )
                                      }
                                    )
                                  : _c("span", [_vm._v("—")]),
                              ],
                              2
                            ),
                            _c("td", [_vm._v(_vm._s(biomarker.roles || "—"))]),
                            _c("td", [
                              _vm._v(_vm._s(biomarker.diseases || "—")),
                            ]),
                            _c("td", [
                              _vm._v(_vm._s(biomarker.recordCount || "—")),
                            ]),
                            _c("td", [
                              _vm._v(_vm._s(_vm.relevanceLabelFor(biomarker))),
                            ]),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  biomarker.relevance
                                    ? biomarker.relevance.rationale
                                    : ""
                                )
                              ),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                  _vm.filteredBiomarkers.length > _vm.perPage
                    ? _c("b-pagination", {
                        staticClass:
                          "pagination-sm justify-content-center mt-2",
                        attrs: {
                          "total-rows": _vm.filteredBiomarkers.length,
                          "per-page": _vm.perPage,
                          size: "sm",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      })
                    : _vm._e(),
                ],
          ]
        : _c("p", { staticClass: "scp-bm-empty" }, [
            _vm._v(
              " No BiomarkerKB biomarkers found for diseases that share genes with the resolved mechanism. "
            ),
          ]),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "scp-bm-pipeline-step" }, [
      _c("span", { staticClass: "scp-bm-pipeline-num" }, [_vm._v("1")]),
      _c("span", { staticClass: "scp-bm-pipeline-text" }, [
        _c("strong", [_vm._v("Mechanism")]),
        _vm._v(
          " — resolve CFDE KG Factor(s) for the hypothesis outcome (reuses a prior CFDE KG selection when available)"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "scp-bm-pipeline-step" }, [
      _c("span", { staticClass: "scp-bm-pipeline-num" }, [_vm._v("2")]),
      _c("span", { staticClass: "scp-bm-pipeline-text" }, [
        _c("strong", [_vm._v("Shared-gene diseases")]),
        _vm._v(
          " — find MONDO diseases that share top genes with that mechanism"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "scp-bm-pipeline-step" }, [
      _c("span", { staticClass: "scp-bm-pipeline-num" }, [_vm._v("3")]),
      _c("span", { staticClass: "scp-bm-pipeline-text" }, [
        _c("strong", [_vm._v("Gene mapping")]),
        _vm._v(
          " — confirm shared genes for disease ranking, and highlight where the hypothesis target appears among biomarker associated genes"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "scp-bm-pipeline-step" }, [
      _c("span", { staticClass: "scp-bm-pipeline-num" }, [_vm._v("4")]),
      _c("span", { staticClass: "scp-bm-pipeline-text" }, [
        _c("strong", [_vm._v("BiomarkerKB")]),
        _vm._v(" — fetch biomarkers linked to those diseases"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Biomarker")]),
        _c("th", [_vm._v("Associated gene")]),
        _c("th", [_vm._v("Roles")]),
        _c("th", [_vm._v("Diseases")]),
        _c("th", [_vm._v("Records")]),
        _c("th", [_vm._v("Relevance")]),
        _c("th", [_vm._v("Relevance rationale")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }